import React from 'react'
import { Form } from 'react-bootstrap'

export default function FaqForm({ register, errors }) {
	return (
		<React.Fragment>
			<Form.Group>
				<Form.Label>Pregunta <span className="text-danger">*</span></Form.Label>
				<Form.Control {...register('question', { required:true })} />
				{ errors.question && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
			</Form.Group>
			<Form.Group>
				<Form.Label>Respuesta <span className="text-danger">*</span></Form.Label>
				<Form.Control as="textarea" {...register('answer', { required:true })} style={{ height: '80px' }} />
				{ errors.answer && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
			</Form.Group>
			<Form.Group>
				<Form.Label>Palabras Clave (para búsqueda)<small>(opcional)</small></Form.Label>
				<Form.Control as="textarea" {...register('keywords')} style={{ height: '80px' }} />
				<Form.Text className="text-muted">
					Las palabras clave se separan por comas.
				</Form.Text>
			</Form.Group>
		</React.Fragment>
	)
}